import React, { useCallback } from "react"
import { useTranslation } from "react-i18next"
import * as Components from "../../components/components"
import { EventBus } from "../../eventbus"
import { RechnungNachlaesseView } from "../RechnungNachlaesseView"
import { RechnungZuschlaegeView } from "../RechnungZuschlaegeView"
import { useGesamtsummen } from "./utils"
import { useStoreRechnung } from "../../store"

export default function GesamtsummenView() {
    const { t } = useTranslation()
    const { steuerDetails, positionen, rechnungAbschlaege, rechnungZuschlaege, gesamtsummen } = useStoreRechnung(
        "steuerDetails",
        "positionen",
        "rechnungAbschlaege",
        "rechnungZuschlaege",
        "gesamtsummen",
    )

    const onChange = useCallback<(path: string) => (value: number | null) => void>(
        (path) => (value) => {
            EventBus.instance.emit("changeProperty", `gesamtsummen.${path}`, value)
        },
        [],
    )
    const { summePositionenNetto, nachlassNetto, zuschlagNetto, gesamtsummeNetto, summeUmsatzsteuer, gesamtsummeBrutto, faelligerBetrag } = useGesamtsummen({
        onChange,
        steuerDetails,
        positionen,
        rechnungAbschlaege,
        rechnungZuschlaege,
        gesamtsummen,
    })

    return (
        <Components.Collapsible title={t("rechnung.gesamtsummen.title")} collapsed={true}>
            <Components.FormGroup label={t("rechnung.gesamtsummen.summePositionenNetto.label")}>
                <Components.NumberEdit value={summePositionenNetto} readonly />
            </Components.FormGroup>

            <Components.FormGroup label={t("rechnung.gesamtsummen.summeAbschlaegeNetto.label")}>
                <Components.NumberEdit value={nachlassNetto} readonly />
            </Components.FormGroup>

            <Components.FormGroup label={t("rechnung.gesamtsummen.summeZuschlaegeNetto.label")}>
                <Components.NumberEdit value={zuschlagNetto} readonly />
            </Components.FormGroup>

            <Components.FormGroup label={t("rechnung.gesamtsummen.gesamtsummeNetto.label")}>
                <Components.NumberEdit value={gesamtsummeNetto} readonly />
            </Components.FormGroup>

            <Components.FormGroup label={t("rechnung.gesamtsummen.summeUmsatzsteuer.label")}>
                <Components.NumberEdit value={summeUmsatzsteuer} readonly />
            </Components.FormGroup>

            {/* BT-111 Nach Abstimmungen in Rahmen von EPE-1210 entfernt, siehe Kommentar in https://jira.de.nortal.com/browse/EPE-1210 */}

            <Components.FormGroup label={t("rechnung.gesamtsummen.gesamtsummeBrutto.label")}>
                <Components.NumberEdit value={gesamtsummeBrutto} readonly />
            </Components.FormGroup>

            <Components.FormGroup label={t("rechnung.gesamtsummen.gezahlterBetrag.label")}>
                <Components.NumberEdit onChange={onChange("gezahlterBetrag")} value={gesamtsummen.gezahlterBetrag} />
            </Components.FormGroup>

            <Components.FormGroup label={t("rechnung.gesamtsummen.rundungsBetrag.label")}>
                <Components.NumberEdit onChange={onChange("rundungsBetrag")} value={gesamtsummen.rundungsBetrag} />
            </Components.FormGroup>

            <Components.FormGroup label={t("rechnung.gesamtsummen.faelligerBetrag.label")}>
                <Components.NumberEdit value={Number(faelligerBetrag.toFixed(2))} readonly />
            </Components.FormGroup>

            {/*BG-20*/}
            <RechnungNachlaesseView />

            {/*BG-21*/}
            <RechnungZuschlaegeView />
        </Components.Collapsible>
    )
}
